var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "projectPropertiesModal",
        size: "lg",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.project_properties"),
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "outline-danger" },
                  on: { click: _vm.deleteProperty },
                },
                [_vm._v(_vm._s(_vm.$t("message.delete")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.projectCreatePropertyModal",
                      modifiers: { projectCreatePropertyModal: true },
                    },
                  ],
                  attrs: { size: "md", variant: "primary" },
                },
                [_vm._v(_vm._s(_vm.$t("message.create_property")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }